
import { Avatar, Box, Chip, Flex, Link } from "../../../../ppui";
import { getOrganizationCategoryNameById } from "./organization-table-constant";

export const headers = [
  {
    key: "slNo",
    label: "SL No.",
    isShortable: true,
    isVisible: true,
    getValue: (row, index) => index + 1,
  },
  {
    key: "company_name",
    label: "Company Name",
    isClickable: true,
    isShortable: true,
    isVisible: true,
    isColumnSticky: true,
    getValue: (row) => (
        <>
          <Link
            to={`/admin/organization/${row?.org_id}`}
            color="secondary"
            underline="none"
          >
            <Flex alignItems="center">
              <Avatar
                className={"avatarHover"}
                size="sm"
                initials={`${row.org_name.trim().substring(0, 1).toUpperCase()}`}
                color="secondary"
                sx={{ marginInlineEnd: "0.625rem" }}
              />
              <Box>
                {row.org_name}
              </Box>
            </Flex>
          </Link>
        </>
      ),
      
  },
  {
    key: "company_type",
    label: "Compaany type",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => getOrganizationCategoryNameById(row.registration_type),
  },
  {
    key: "phone",
    label: "Phone",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.phone
  },
  {
    key: "email",
    label: "Email",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.email,
  },
  {
    key: "address", // Fixed typo in "addres"
    label: "Address",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => {
      return (
        [
          row?.address,
          row?.city,
          row?.indian_states?.state_name,
          row?.country,
          row?.pincode,
          row?.locality,
        ]
          .filter(Boolean)
          .join(", ") || "No address available"
      );
    },
  },  
  {
    key: "no_of_employee",
    label: "No of employee",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.employeeCount,
  },
  {
    key: "status",
    label: "Status",
    isShortable: false,
    isVisible: false,
    getValue: (row) => <>
      <Chip
        color={
          row.status === "approved"
            ? "success"
            : row.status === "pending"
              ? "warning"
              : row.status === "rejected"
                ? "danger"
                : "default"
        }
        label={row.status ? row.status : "NA"}
        variant="filled"
        noHover
        dot
        sx={{ textTransform: "capitalize" }}
      />
    </>
  },
];

